export class ApiError extends Error {
    constructor(public status: number, message: string) {
        const info = status +': '+ message
        super(info);
        this.name = 'ApiError';
    }
}

export class TypedError extends Error {
    constructor(message?: string) {
        super(message);
        this.name = 'TypeError';
    }
}


export class ValidationError extends Error {
    constructor(message?: string) {
        super(message);
        this.name = 'ValidationError';
    }
}

export class NetworkError extends Error {
    constructor(message?: string) {
        super(message);
        this.name = 'NetworkError';
    }
}

export class UnauthorizedError extends Error {
    constructor(message?: string) {
        super(message);
        this.name = 'UnauthorizedError';
    }
}